export default function Industries() {
  return (
    <section id="industries" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-16 text-center">
          Industries We Strengthen
        </h2>
        <div className="grid md:grid-cols-2 gap-12">
          <div className="bg-white border border-gray-200">
            <div className="relative w-full h-[280px]">
              <img
                src="https://public.readdy.ai/ai/img_res/91b9571552340e5ea38f1e16c50e5d0c.jpg"
                alt="Home Services AI Solutions"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="p-10">
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className="ri-tools-line text-4xl text-[#0F172A]"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Home Services</h3>
              <p className="text-base text-gray-600 mb-6 font-medium">
                Operational Intelligence for Trades & Service Operators
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-checkbox-line text-lg text-[#0F172A] mt-0.5 mr-3"></i>
                  <span className="text-gray-700 text-sm">AI Lead Routing & Qualification</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-line text-lg text-[#0F172A] mt-0.5 mr-3"></i>
                  <span className="text-gray-700 text-sm">Smart Dispatch & Scheduling Systems</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-line text-lg text-[#0F172A] mt-0.5 mr-3"></i>
                  <span className="text-gray-700 text-sm">Revenue Forecast & Job Pipeline Visibility</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-line text-lg text-[#0F172A] mt-0.5 mr-3"></i>
                  <span className="text-gray-700 text-sm">Automated Review & Reputation Engine</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-line text-lg text-[#0F172A] mt-0.5 mr-3"></i>
                  <span className="text-gray-700 text-sm">Predictive Maintenance & Repeat Revenue Systems</span>
                </li>
              </ul>
              <p className="text-sm text-gray-600 font-medium">
                More booked jobs. Fewer missed opportunities. Clear reporting.
              </p>
            </div>
          </div>

          <div className="bg-white border border-gray-200">
            <div className="relative w-full h-[280px]">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20financial%20services%20office%20with%20modern%20AI%20technology%20systems%20showing%20client%20management%20automation%20compliance%20workflows%20and%20data%20analytics%20dashboards%20clean%20corporate%20environment%20with%20structured%20processes%20navy%20blue%20and%20white%20professional%20aesthetic%20financial%20technology%20visualization&width=800&height=560&seq=industry-finance-001&orientation=landscape"
                alt="Financial Services AI Solutions"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="p-10">
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className="ri-line-chart-line text-4xl text-[#0F172A]"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Financial Services</h3>
              <p className="text-base text-gray-600 mb-6 font-medium">
                Precision Infrastructure for Financial Firms
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-checkbox-line text-lg text-[#0F172A] mt-0.5 mr-3"></i>
                  <span className="text-gray-700 text-sm">Intelligent Client Intake Automation</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-line text-lg text-[#0F172A] mt-0.5 mr-3"></i>
                  <span className="text-gray-700 text-sm">AI Lead Scoring & Qualification</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-line text-lg text-[#0F172A] mt-0.5 mr-3"></i>
                  <span className="text-gray-700 text-sm">Compliance Workflow Systems</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-line text-lg text-[#0F172A] mt-0.5 mr-3"></i>
                  <span className="text-gray-700 text-sm">Document & Agreement Automation</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-line text-lg text-[#0F172A] mt-0.5 mr-3"></i>
                  <span className="text-gray-700 text-sm">Renewal & Retention Optimization</span>
                </li>
              </ul>
              <p className="text-sm text-gray-600 font-medium">
                Structured pipelines. Reduced friction. Higher client lifetime value.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}